import { useNavigate, useLocation } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components";
const UnauthorizedUser = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const errorMessage = location.state?.error || "Access Denied";

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background via-background_2 to-background p-6">
      <div className="bg-secondary rounded-[32px] shadow-2xl p-8 max-w-lg w-full text-center">
        <div className="flex justify-center mb-4">
          <XCircle className="w-20 h-20 text-background/90" />
        </div>
        <h1 className="text-4xl font-bold text-background/95 mb-2">
          {errorMessage}
        </h1>
        <p className="text-background/60 text-lg mb-6">
          Oops! It looks like you don't have the required permissions to access
          this page.
        </p>
        <Button
          onClick={() => navigate("/")}
          className="w-full py-3 bg-secondary hover:!bg-background/10 text-background font-semibold rounded-lg transition-colors"
        >
          Go Back Home
        </Button>
      </div>
    </div>
  );
};

export default UnauthorizedUser;
